import { SearchInput, Spinner } from 'evergreen-ui';
import React, { ChangeEvent, useState } from 'react';
import { BehaviorSubject, Observable } from 'rxjs';
import { useObservable } from 'rxsupport';
import { useCurrentUser } from 'security';
import { canSearchAcrossProvider } from '../domain/security';

type UserFilterInputProps = {
    isRunning$: Observable<boolean>,
    currentFilter$: BehaviorSubject<string>,
};
export const UserFilterInput = ({ currentFilter$, isRunning$ }: UserFilterInputProps) => {
    const [filterKeyword, setFilterKeyword] = useState('');
    const loading = useObservable(isRunning$, true);

    const currentUser = useCurrentUser()!;
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        currentFilter$.next(filterKeyword)
    };
    return (
        <form className="flex" onSubmit={(e) => handleSubmit(e)}>
            <SearchInput
                onChange={(event: ChangeEvent<HTMLInputElement>) => setFilterKeyword(event.target.value)}
                value={filterKeyword}
                placeholder={
                    canSearchAcrossProvider(currentUser) ?
                        'Search by provider, name, or email' :
                        'Search by name, or email'
                }
                className='ev-overwrite ev-user-provider-search-bar'
                maxLength={128}
                height={40} width={470} marginY={16}
                disabled={loading}
            />
            <button className='bg-atlantis-200 hover:bg-atlantis-300
                h-10 w-24 my-4 text-white font-semibold text-sm
                outline-none focus:outline-none rounded-r disabled:opacity-50'
                disabled={loading}
                type="submit">
                {loading ? <Spinner data-testid="um-user-filter-input-spinner" size={16} marginX='auto' className='ev-overwrite white-spinner' /> : 'Search'}
            </button>
        </form>
    );
}
